import useOnPressKey from '#hooks/onKeyPress/useOnPressKey'

const useOnPressEscKey = callback => {
  const escKey = 27
  useOnPressKey(callback, escKey)
}

export default useOnPressEscKey
